import { WheelData } from '../../../../types';

// Cores mais vibrantes e saturadas usadas na roda
export const WHEEL_COLORS = [
  '#8B2FC9', // Roxo vibrante
  '#E91E8C', // Pink
  '#E91E63', // Pink escuro
  '#F44336', // Vermelho
  '#FF9800', // Laranja
  '#FFC107', // Amarelo
  '#CDDC39', // Lima
  '#8BC34A', // Verde claro
  '#4CAF50', // Verde
  '#00BCD4', // Cyan
  '#2196F3', // Azul
  '#3F51B5', // Azul índigo
];

interface CreateWheelParams {
  wheelData: WheelData;
  wheelSize: number;
  stopAngle: number;
  onFinished: () => void;
  onSound: () => void;
}

/**
 * Cria e configura a roda de prêmios com Winwheel.js
 */
export const createWheelInstance = ({
  wheelData,
  wheelSize,
  stopAngle,
  onFinished,
  onSound
}: CreateWheelParams) => {
  // Ajustar tamanho da fonte baseado no tamanho da roda
  const numSegments = wheelData.products.length;
  const fontSize = Math.max(14, Math.floor(wheelSize / 25));
  
  const radius = (wheelSize / 2) - 17; // Raio com margem para os pins

  const segments = wheelData.products.map((product, index) => {
    // Truncar texto muito longo baseado no número de segmentos
    let displayText = product.name;
    let maxLength = 15;
    
    if (numSegments <= 6) {
      maxLength = 20;
    } else if (numSegments <= 8) {
      maxLength = 15;
    } else if (numSegments <= 12) {
      maxLength = 12;
    } else {
      maxLength = 10;
    }
    
    if (displayText.length > maxLength) {
      displayText = displayText.substring(0, maxLength - 2) + '..';
    }
    
    return {
      fillStyle: WHEEL_COLORS[index % WHEEL_COLORS.length],
      text: displayText,
      textFillStyle: '#FFFFFF',
      textFontSize: fontSize,
      textFontFamily: 'Arial, sans-serif',
      textFontWeight: 'bold',
    };
  });

  const Winwheel = (window as any).Winwheel;
  
  return new Winwheel({
    canvasId: 'wheelCanvas',
    numSegments: segments.length,
    outerRadius: radius,
    innerRadius: 40, // Centro vazio para o botão
    textFontSize: fontSize,
    textOrientation: 'horizontal',
    textAlignment: 'center',
    textDirection: 'normal',
    textMargin: 0,
    textFontFamily: 'Arial, sans-serif',
    textFontWeight: 'bold',
    segments: segments,
    lineWidth: 3,
    strokeStyle: '#FFFFFF', // Bordas brancas entre segmentos
    animation: {
      type: 'spinToStop',
      duration: 5,
      spins: 3,
      callbackFinished: onFinished,
      callbackSound: onSound,
      soundTrigger: 'pin',
      stopAngle: stopAngle
    },
    pins: {
      number: 16,
      fillStyle: 'transparent',
      outerRadius: 0,
      margin: 0,
    }
  });
};
